/**
 * Created by shubham on 20/4/18.
 */

import {Component, ViewChild, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HttpService} from '../shared/services/http.service';
import {SessionHandler} from '../shared/services/session-handler.service';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {MdDialog} from '@angular/material';
import {DialogComponent, WelcomeDialogComponent} from '../dialog/dialog.component';
import {CommonService} from '../shared/services/common.service';
import {FormGroup, FormBuilder} from '@angular/forms';
import {AdminPage} from "./admin-datatable/admin-page";
import {APPCONFIG} from '../config';
import {AdminDashboardResultService} from '../adminDashboardResultService';
import {TranslateService} from 'ng2-translate';


@Component({
    selector: 'admin-dashboard',
    template: require('./admin-dashboard.component.html'),
    styles: [require('../../app/newCommon.scss')],

})
export class AdminDashboardComponent {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    dialogRef;
    userDetails: any;
    page = new AdminPage();
    tableRows: any = [];
    filters: any = {};
    rows: any;
    adminDashboardData = [];
    temp = [];
    Countries = [{
        "id": "",
        "name": "all",
        "code": "",
        "active": true,
        "createdAt": "2019-02-26T12:49:39.329Z"
    }];
    showTable: boolean = true;
    isSystemAdmin: boolean = false;
    isBUManager: boolean = false;
    isRegionalAdmin: boolean = false;
    isServiceOwner: boolean = false;
    isTradePartner: boolean = false;
    isSubUser: boolean = false;
    selected = [];
    adminText: any;
    selectedStatusId: string = 'PENDING';
    selectedCountryId: string = '';
    selectedCount: any;
    count: any;
    totalCount: any;
    searchedFilters = {email: '', firstName: '', wpassId: ''};
    isDisabled = false;
    showCheckbox = false;
    wpassLogin: boolean = false;
    autocompleteLoader: string = "";

    searchName = "";
    searchEmail = "";
    searchWpass = "";
    Names: Array<any> = [];
    Emails: Array<any> = [];
    Wpass: Array<any> = [];
    dataTableMessage = {'selectedMessage': '', 'totalMessage': ''};
    StatusData = [{
        "id": "PENDING",
        "code": "",
        "name": "Pending"
    }];

    constructor(private router: Router, private httpService: HttpService, private sessionHandler: SessionHandler, public dialog: MdDialog,
                private formBuilder: FormBuilder, private serverResultsService: AdminDashboardResultService, private commonService: CommonService,
                private translate: TranslateService) {

        //Close Sidebar Initially
        APPCONFIG.navCollapsed = true;

        this.page.pageNumber = 0;
        this.page.size = 20;
        this.adminText = 'admin';

        /*this.wpassLogin = JSON.parse(this.sessionHandler.getItem('wpassLogin'));
        if(this.wpassLogin != null && this.wpassLogin == true){
            this.dialogRef = this.dialog.open(WelcomeDialogComponent);
            this.dialogRef.afterClosed().subscribe(result => {
                localStorage.removeItem('wpassLogin');
            });
        }*/

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isBUManager || this.isRegionalAdmin || this.isSystemAdmin) {
            this.getCountries();
            this.getStatusList();
            this.getUsersList(this.filters, this.selectedStatusId, this.selectedCountryId, this.searchEmail, this.searchName, this.searchWpass);
        } else {
            this.getUserList();
        }

        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.adminDashboard.subscribe((value) => {
            this.getUsersList(this.filters, this.selectedStatusId, this.selectedCountryId, this.searchEmail, this.searchName, this.searchWpass);
        });
    }

    autocompleteSearch(term: string, filter: string) {
        if (filter == "name") {
            this.Names = [];
            this.searchName = term;
        } else if (filter == "email") {
            this.Emails = [];
            this.searchEmail = term;
        } else if (filter == "wpass") {
            this.Wpass = [];
            this.searchWpass = term;
        }

        if (term == "") return;

        let url = "/lookupDataOperationsApi/v1/partialSearch?type=" + filter + "&searchStr=" + term;
        this.autocompleteLoader = filter;
        this.httpService.getRequestForAutocomplete(url).subscribe(
            res => {
                if (res && res['items']) {
                    let name = res['items'];
                    let filterArray = [];

                    for (let index in name) {
                        filterArray.push(name[index]['name']);
                    }

                    if (filter == "name") {
                        this.Names = filterArray;
                    } else if (filter == "email") {
                        this.Emails = filterArray;
                    } else if (filter == "wpass") {
                        this.Wpass = filterArray;
                    }
                }
                this.autocompleteLoader = "";
                this.httpService.onEnd();
            },
            err => {
                this.autocompleteLoader = "";
                this.httpService.onEnd();
            })
    }

    onSelectAutocomplete(value, textFlag) {
        if (textFlag == "name") {
            this.searchName = value;
        } else if (textFlag == "email") {
            this.searchEmail = value;
        } else if (textFlag == "wpass") {
            this.searchWpass = value;
        }
    }

    public search() {
        this.selected = [];
        this.filters['offSet'] = 0;

        /*if (this.searchName == undefined) {
            this.searchName = "";
        } else if(this.searchName != "" && this.Names.length > 0){
            if(this.checkAutocompleteWord(this.Names, this.searchName)){
                this.searchName = "";
            }
        }

        if (this.searchEmail == undefined) {
            this.searchEmail = "";
        } else if(this.searchEmail != "" && this.Emails.length > 0){
            if(this.checkAutocompleteWord(this.Emails, this.searchEmail)){
                this.searchEmail = "";
            }
        }

        if (this.searchWpass == undefined) {
            this.searchWpass = "";
        } else if(this.searchWpass != "" && this.Wpass.length > 0){
            if(this.checkAutocompleteWord(this.Wpass, this.searchWpass)){
                this.searchWpass = "";
            }
        }*/
        if (this.searchName == undefined) { this.searchName = "";}
        if (this.searchEmail == undefined) { this.searchEmail = "";}
        if (this.searchWpass == undefined) { this.searchWpass = "";}
        this.getUsersList(this.filters, this.selectedStatusId, this.selectedCountryId, this.searchEmail, this.searchName, this.searchWpass);
    }

    checkAutocompleteWord(objArray, searchValue){
        if(objArray.includes(searchValue)){
            return false;
        } else {
            return true;
        }
    }

    public resetSearch() {

        this.searchName = "";
        this.searchEmail = "";
        this.searchWpass = "";
        this.Names = [];
        this.Emails = [];
        this.Wpass = [];
        this.selectedStatusId = "PENDING";
        this.selectedCountryId = "";

        this.search();
    }

    public getCountries() {
        this.httpService.getRequest('lookupDataOperationsApi/v1/countriesForAdmin').subscribe(
            res => {
                this.saveCountries(res);
            },
            err => {
                this.httpService.onEnd();
            }
        );
    }

    public saveCountries(res) {
        if (res && res.items) {
            this.Countries = this.Countries.concat(res.items);
        }
        this.httpService.onEnd();
    }

    public getStatusList() {
        this.httpService.getRequest("lookupDataOperationsApi/v1/registrationStatusFilter?includeDeleted=true").subscribe(
            res => {
                this.saveStatusList(res);
            },
            err => {
                this.httpService.onEnd();
            }
        );
    }

    public saveStatusList(res) {
        this.StatusData.push({"id":"", "code":"", "name":"all"});
        if (res) {
            if (res.items) {
                for (let s in res.items) {
                    if (res.items[s]['id'] != 'PENDING') {
                        this.StatusData.push(res.items[s]);
                    }
                }
            }
        }
    }

    public getUsersList(filter, selectedStatus, selectedCountryId, email, firstName, wpassId) {
        this.searchedFilters.email = email;
        this.searchedFilters.firstName = firstName;
        this.searchedFilters.wpassId = wpassId;

        if (selectedStatus == 'PENDING') {
            this.showCheckbox = true;
        } else {
            this.showCheckbox = false;
        }

        this.httpService.getRequest("userRegistrationsApi/v1/user/list?limit=" + filter.limit + "&offset=" + filter.offSet + "&status=" + selectedStatus + "&countryId=" + selectedCountryId + "&email=" + email + "&firstName=" + firstName + "&wpassId=" + wpassId).subscribe(
            res => {
                this.saveUserList(res, filter);
            },
            err => {
                this.httpService.onEnd();
            }
        );
    }

    public getUserList = function () {
        this.showTable = false;
    };

    public saveUserList = function (res, filter) {
        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if (res && Object.keys(res).length > 0) {
                this.adminDashboardData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;
                this.count = res.count;
                this.totalCount = res.totalCount;

                if (this.adminDashboardData.list) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.adminDashboardData.list) {
                        if (this.isBUManager || this.isRegionalAdmin || this.isSystemAdmin) {
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.adminDashboardData.list[data]['id'];
                            this.rows[data]['Name'] = this.adminDashboardData.list[data]['firstName'] + ' ' + this.adminDashboardData.list[data]['lastName'];
                            this.rows[data]['roleName'] = this.adminDashboardData.list[data]['roleName'];
                            this.rows[data]['email'] = this.adminDashboardData.list[data]['email'];
                            this.rows[data]['emailVerified'] = this.adminDashboardData.list[data]['emailVerified'];

                            if (this.adminDashboardData.list[data]['categorizedBusinessUnits'] && Object.keys(this.adminDashboardData.list[data]['categorizedBusinessUnits']).length > 0) {
                                this.rows[data]['businessUnits'] = this.adminDashboardData.list[data]['categorizedBusinessUnits'];
                            } else {
                                this.rows[data]['businessUnits'] = null;
                            }

                            if (this.adminDashboardData.list[data]['userId_WPASS']) {
                                this.rows[data]['userId_WPASS'] = this.adminDashboardData.list[data]['userId_WPASS'];
                            } else {
                                this.rows[data]['userId_WPASS'] = null;
                            }

                            if (this.adminDashboardData.list[data]['pendingSubUserCount']) {
                                this.rows[data]['pendingSubUserCount'] = this.adminDashboardData.list[data]['pendingSubUserCount'];
                            } else {
                                this.rows[data]['pendingSubUserCount'] = 0;
                            }

                            this.rows[data]['languageId'] = this.adminDashboardData.list[data]['languageId'];
                            this.rows[data]['languageName'] = this.adminDashboardData.list[data]['languageName'];
                            this.rows[data]['countryId'] = this.adminDashboardData.list[data]['countryId'];
                            this.rows[data]['countryName'] = this.adminDashboardData.list[data]['countryName'];
                            this.rows[data]['companyName'] = this.adminDashboardData.list[data]['companyName'];
                            this.rows[data]['companyAddress'] = this.adminDashboardData.list[data]['companyAddress'];
                            this.rows[data]['companyPhone'] = this.adminDashboardData.list[data]['companyPhone'];
                            this.rows[data]['personalArea'] = this.adminDashboardData.list[data]['personalArea'];
                            this.rows[data]['costCenter'] = this.adminDashboardData.list[data]['costCenter'];
                            this.rows[data]['location'] = this.adminDashboardData.list[data]['location'];
                            this.rows[data]['contractorType'] = this.adminDashboardData.list[data]['contractorType'];

                            if ((this.adminDashboardData.list[data]['status'] == "Pending" || this.adminDashboardData.list[data]['status'] == "Approved")
                                && this.adminDashboardData.list[data]['categorizedBusinessUnits'] && this.adminDashboardData.list[data]['categorizedBusinessUnits']['PENDING']) {
                                for (let businessUnit of this.adminDashboardData.list[data]['categorizedBusinessUnits']['PENDING']) {
                                    if (businessUnit.status == 'PENDING' && businessUnit.sessionUserManager) {
                                        this.rows[data]['actionFlag'] = true;
                                        if (businessUnit.customerNumber) {
                                            this.rows[data]['customerNumber'] = businessUnit.customerNumber;
                                        }
                                        if (businessUnit.customerNumberMandatory) {
                                            this.rows[data]['customerNumberMandatory'] = businessUnit.customerNumberMandatory;
                                        }
                                        if (businessUnit.id) {
                                            this.rows[data]['businessUnitId'] = businessUnit.id;
                                        }
                                        break;
                                    } else {
                                        this.rows[data]['actionFlag'] = false;
                                    }
                                }
                            } else {
                                this.rows[data]['actionFlag'] = false;
                            }
                            this.rows[data]['status'] = this.adminDashboardData.list[data]['status'];
                            this.rows[data]['createdAt'] = this.adminDashboardData.list[data]['createdAt'];
                            this.rows[data]['updatedAt'] = this.adminDashboardData.list[data]['updatedAt'];
                            this.rows[data]['wpassCreatedAt'] = this.adminDashboardData.list[data]['wpassCreatedAt'];
                        } else {
                            //For Other Service Partner's
                            this.rows[data] = {};
                        }
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else {
                    this.showTable = false;
                }

                let finalRows = [];
                for (let f in this.rows) {
                    if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                        finalRows.push(this.rows[f]);
                    }
                    if (f == 'offset') {
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if (f == 'totalCount') {
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({offset: this.rows['offset'] / this.page.size}, finalRows, filter);
                this.httpService.onEnd();
            }
        }
    };

    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    public setPage(pageInfo, rows, filter) {
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']) {
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        this.getUsersList(this.filters, this.selectedStatusId, this.selectedCountryId, this.searchEmail, this.searchName, this.searchWpass);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }

    onSelect({selected}) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
        this.selectedCount = this.selected.length;
    }

    public forgetPassword(wpassId) {
        this.dialogRef = this.dialog.open(DialogComponent);
        this.dialogRef.componentInstance.msg = 'sure_to_init_reset_process';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(data => {
            if (data) {
                var body = {userId_WPASS: wpassId};
                this.httpService.postRequest(body, 'userOperationsApi/v1/forgotPassword').subscribe(
                    res => {
                        this.processResponse(res, 'after_reset_password_notify');
                    },
                    err => {
                        this.httpService.onEnd();
                    }
                );
            } else {
            }
        });

    }

    downloadCsv(action) {
        let loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        let accessToken;

        if (loginDataArray) {
            accessToken = loginDataArray['accessToken'];
        }
        window.open(APPCONFIG.URL + '/export?access-token=' + accessToken + '&action='+action+'&status=' + this.selectedStatusId + '&email=' + this.searchEmail + '&firstName=' + this.searchName + '&wpassId=' + this.searchWpass + '&countryId=' + this.selectedCountryId, '_blank');
    }

    public processResponse(res, msgCode) {
        if (res) {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = msgCode;
            this.dialogRef.afterClosed().subscribe(result => {
            });
        }
        this.httpService.onEnd();
    }

    public unlockAccount(wpassId) {
        this.dialogRef = this.dialog.open(DialogComponent);
        this.dialogRef.componentInstance.msg = 'sure_to_init_unlock_process';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(data => {
            if (data) {
                var body = {userId_WPASS: wpassId};
                this.httpService.postRequest(body, 'userOperationsApi/v1/unlockWpassUser').subscribe(
                    res => {
                        this.processResponse(res, 'account_unlock_succesfully');
                    },
                    err => {
                        this.httpService.onEnd();
                    }
                );
            }
        });
    }

    public resendEmailVerificationEmail(userId) {
        this.dialogRef = this.dialog.open(DialogComponent);
        this.dialogRef.componentInstance.msg = 'sure_to_resend_email_verification_link';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(data => {
            if (data) {
                var body = {};
                this.httpService.postRequest(body, 'userRegistrationsApi/v1/resendNewRegistrationEmailVerificationEmail/' + userId).subscribe(
                    res => {
                        this.processResponse(res, 'email_sent_success');
                    },
                    err => {
                        this.httpService.onEnd();
                    }
                );
            }
        });
    }

    ngOnInit() {
        this.translate.get('total').subscribe((res: string) => {
            this.dataTableMessage.totalMessage = res;
        });
        this.translate.get('selected').subscribe((res: string) => {
            this.dataTableMessage.selectedMessage = res;
        });
    }

    ngOnDestroy() {
        this.dialog.closeAll();
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-dashboard/admin-dashboard.component.ts